<template>
	<div id="">
		<Row style="padding-top: 20px;">
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
			<div class="input-group">
				<span class="input-group-addon">状态</span>
				<Select v-model="memoStatus" placeholder="状态" @on-change="mySearch">
					<Option v-for="item in memoStatusFilters" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
			</div>
			</Col>
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
			<div class="input-group">
				<span class="input-group-addon">选择时间</span>
				<Select v-model="timePeriod" placeholder="选择时间" @on-change="mySearch">
					<Option v-for="item in memoTimeFilters" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
			</div>
			</Col>
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" v-if="timePeriod == 7">
				<DatePicker type="daterange" placeholder="备忘时间" :value="timePeriodDate" @on-change="changeTimePeriod">
				</DatePicker>
			</Col>
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" >
				<Input v-model="remark" placeholder="备注" @on-change="mySearch"  />
			</Col>
			<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<Button @click="mySearch" type="primary" style="margin-left: 20px;">刷新</Button>
				<Button @click="mySearch" type="primary" style="margin-left: 20px;">查询</Button>
			</Col>
		</Row>
		<div style="width: 100% ;margin-top: 20px;height: 600px;">
			<Table :columns="memorandumColumns" :data="datas" size="small" ref="table">
			</Table>
			<div>
				<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
					:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
			</div>	
		</div>
	
	</div>
</template>

<script>
	import quickEditClue from './quickEditClue.vue'
	import EditClue from './EditClue.vue'
	import NewEditClue from './NewEditClue.vue'
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getFollowList
	} from '@/api/client'
	export default {
		name: "Memo",
		components: {
			quickEditClue,
			EditClue,
			NewEditClue
		},
		data() {
			return {
				memoStatus:0,
				timePeriod:1,
				datas:[],
				count: 0,
				page: 1,
				pageSize: 10,
				remark:'',
				pageSizeOpts: [10, 50, 100, 200, 500],
				timePeriodDate: [],
				memoStatusFilters:[
					{
						value: 0,
						label: '未过期'
					},
					{
						value: 1,
						label: '已过期'
					},
				],
				memoTimeFilters: [{
						value: 0,
						label: '不限'
					},
					{
						value: 1,
						label: '今天'
					},
					{
						value: 2,
						label: '昨天'
					},
					{
						value: 3,
						label: '本周'
					},
					{
						value: 4,
						label: '上周'
					},
					{
						value: 5,
						label: '本月'
					},
					{
						value: 6,
						label: '上月'
					},
					{
						value: 7,
						label: '自定义'
					},
				],
				memorandumColumns:[
						{
							type: 'selection',
							width: 40,
							align: 'center'
						},
						{
							"title": "备忘提醒时间",
							"key": "plan_at",
							"width": 50
						},
						{
							"title": "备忘姓名",
							"key": "name",
							"width": 80
						},
						{
							"title": "备忘内容",
							"key": "remark",
							"width": 80
						},
						{
							"title": "状态",
							"key": "status",
							"width": 80
						},						
				],
			}
		},
		computed: {
			...mapGetters(['token']),
		},
		mounted: function() {
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch(){
				this.page = 1;
				this.getList();
			},
			initSearch() {
				this.memoTime=0,
				this.memoStatus=0;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeTimePeriod(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			async getList() {

				let that = this;
				var data = this.$data;
				data.limit = this.pageSize;
				data.token = this.token;
				data.page = this.page;
				let res = await getFollowList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
		}
	}
</script>
<style scoped lang="less">
	/*栅格表开始*/
	.selectdiv .panel-body {
		padding: 20px 10;
		width: 100%;
		display: inline-block;
	}

	.selectdiv .btn {
		border-radius: 2px;
		margin: 5px 5px;
	}

	.team_btn1_rf {
		margin-top: 5px;
	}

	.rili_out {
		height: 36px;
		float: right;
		position: relative;
	}

	.rili_out .main_data {
		position: absolute;
		left: 0;
		top: 40px;
		z-index: 99;
		background: #ffffff;
		padding: 10px;
		border-radius: 4px;
		border: 1px #dddddd solid;
	}

	.rili_out .prompt {
		position: absolute;
		right: 4px;
		top: 4px;
		width: 8px;
		height: 8px;
		background: red;
		border-radius: 50%;
		border: 1px #ffffff solid;
	}

	.rili_out .btn_closerl {
		position: absolute;
		right: -10px;
		top: -10px;
		cursor: pointer;
	}

	#lk_content .callrecord {
		min-width: 1400px;
	}

	.callrecord-top {
		color: #FFFFFF;
		background-color: #db5a63;
	}

	#lk_content {
		width: 100%;
	}

	.callrecord .acco {
		cursor: pointer;
		color: red;
	}

	.callrecord .next2 {
		cursor: pointer;
		color: #8B0000;
	}

	#lk_content .callrecord-top .tit7 {
		width: 300px;
	}

	#lk_content .callrecord-top .tit15 {
		width: 120px;
	}

	#lk_content .callrecord-top .tit16 {
		width: 120px;
	}
</style>
<style scoped lang="less">
	.input-group .chaxun {
		padding: 6px;
	}

	.input-group .my_client {
		height: 30px;
		background: none;
		border-left: 1px #CCCCCC solid;
		padding: 6px 0;
	}

	.p {
		color: #409eff;
	}

	.form-list .info-inline .name {
		float: left;
		line-height: 38px;
		background: #f0f0f0;
		border-right: 1px solid #ddd;
		padding: 0 18px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	.form-list {
		width: 100%;
		display: inline-block;
		clear: both;
		padding: 8px 0;
	}

	.form-list .info-inline {
		width: 16%;
		height: 40px;
		float: left;
		margin: 7px .5%;
	}

	.form-list .bor-al,
	.form-list .bor-at {
		border: 1px solid #ddd;
		border-radius: 4px;
		width: 49%;
		float: left;
	}

	.form-list .bor-al,
	.form-list .bor-at {
		border: 1px solid #ddd;
		border-radius: 4px;
		width: 49%;
		float: left;
	}

	.form-list .info-inline .right {
		overflow: auto;
		position: relative;
	}

	.form-list .mar-let {
		margin-left: 2%;
	}

	.hong {
		color: #F56171;
		font-weight: bold;
		cursor: pointer;
	}

	.lan {
		color: #124386;
		font-weight: bold;
		cursor: pointer;
	}

	.sousuo {
		width: 100%;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	/deep/ .ivu-modal-content {
		background-color: #f9fafc;
	}

	/deep/ .ivu-table-header thead tr th {
		text-align: center !important;
	}

	/deep/ .ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	/deep/ .ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.count_tips {
		color: rgb(0, 0, 0);
		justify-content: center !important;
		background: rgb(229, 245, 253);
		width: 1400px;
		margin: 0 auto;
		/* padding: 5px; */
		line-height: 35px;
		height: 35px;
	}

	.count_tips_img {
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-right: 5px;
		margin-bottom: 3px;
	}

	.announce_div {
		position: relative;
		background-color: #F2F2F2;
		color: #E8410B;
		margin-bottom: 20px;
	}

	.announce_img {
		position: absolute;
		left: 4px;

		img {
			width: 20px;
			height: 20px;
			margin-top: 5px;
		}
	}

	.announce_area {
		margin-left: 25px;
		overflow: hidden;

		marquee {
			margin-top: 5px;
		}
	}

	.inline {
		display: inline-block;
		width: 30%;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
